import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { modalBoxStyle } from "./styles";
import {
  CircularProgress,
  Button,
  Typography,
  Box,
  Modal,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

const EditAreaModal = ({
  isOpen,
  toggleModalOpen,
  buttonText,
  headerText,
  loading,
  updateArea,
  area,
}) => {
  const { register, handleSubmit, reset } = useForm({ defaultValues: area });

  useEffect(() => {
    reset(area);
  }, [area]);

  const closeModal = () => {
    toggleModalOpen(false);
  };

  const handleAreaSubmit = async (data) => {
    await updateArea(data.name);
    reset();
  };

  return (
    <Modal
      open={isOpen}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalBoxStyle}>
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </div>
        ) : (
          <form onSubmit={handleSubmit(handleAreaSubmit)}>
            <Grid
              container
              direction="column"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid
                container
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Grid item>
                  <Typography variant="h2">{headerText}</Typography>
                </Grid>
                <Grid item>
                  <IconButton
                    sx={{ backgroundColor: "transparent" }}
                    onClick={closeModal}
                  >
                    <CloseOutlinedIcon />
                  </IconButton>
                </Grid>
              </Grid>
              <Box sx={{ marginTop: 8, width: "100%" }}>
                <TextField
                  size="small"
                  fullWidth
                  label="Name"
                  autoComplete="off"
                  placeholder="Enter Name"
                  {...register("name", { required: true })}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "3rem",
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    width: "300px",
                    height: "40px",
                    borderRadius: 2,
                    paddingTop: 2,
                    paddingBottom: 2,
                    paddingLeft: 6,
                    paddingRight: 6,
                  }}
                  type="submit"
                  disabled={loading}
                >
                  <Typography variant="largeButton">{buttonText}</Typography>
                </Button>
              </Box>
            </Grid>
          </form>
        )}
      </Box>
    </Modal>
  );
};

export default EditAreaModal;
